import { Suspense } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import SectionTabs from '../../../components/common/SectionTabs.jsx'
import { CONTRACT_SECTIONS } from '../sections.js'
import QuoteEditorPage from './QuoteEditorPage.jsx'
import ContractEditorPage from './ContractEditorPage.jsx'

/**
 * Contrats : devis, contrats et factures.
 *   /dashboard/contrats                 -> Devis
 *   /dashboard/contrats/:section        -> l'onglet choisi
 *   /dashboard/contrats/devis/:quoteId  -> un devis
 *   /dashboard/contrats/contrats/:contractId -> un contrat
 */
export default function ContractsPage() {
  const { section: sectionKey, quoteId, contractId } = useParams()
  const section = CONTRACT_SECTIONS.find((s) => s.key === (quoteId ? 'devis' : contractId ? 'contrats' : sectionKey))
  if (!section) return <Navigate to={`/dashboard/contrats/${CONTRACT_SECTIONS[0].key}`} replace />

  const Screen = section.component

  return (
    <div>
      <SectionTabs
        label="Contrats"
        activeKey={section.key}
        tabs={CONTRACT_SECTIONS.map((s) => ({ ...s, to: `/dashboard/contrats/${s.key}` }))}
      />
      <Suspense
        fallback={(
          <div className="flex items-center justify-center py-20 text-ink/50">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        )}
      >
        {quoteId && <QuoteEditorPage quoteId={quoteId} />}
        {contractId && <ContractEditorPage contractId={contractId} />}
        {!quoteId && !contractId && <Screen />}
      </Suspense>
    </div>
  )
}
